import {
	PREVIEW_2_ADTYPES,
	PREVIEW_2_URL,
	TIA_DOMAIN_PUBLIC,
	DYNAMIC_PREROLL
} from "utils/constants";
import { getPRVW } from "utils/Flags";

export const SHARE_CREATIVE_PREVIEWS_FORM = "ShareCreativePreviews";

export function buildBulkSharableLink(publicId, links = [], useVersionLinks = false){
	const hasLegacyPreviewCreative = links.find((link) => {
		const { creative = {} } = link || {};

		/*
			One of the links may be the link for the batch, which doesn't have a creative,
			but `creative` may be an empty object, so we just do a basic check for keys,
			so we don't factor it in when determining if a legacy preview creative is present.
		*/
		return Object.keys(creative).length && (getPreviewURLForCreative(creative) === TIA_DOMAIN_PUBLIC);
	});

	// If any of the links are legacy previews, we need to use the legacy preview URL
	const baseURL = hasLegacyPreviewCreative ? TIA_DOMAIN_PUBLIC : PREVIEW_2_URL;
	const previewScope = useVersionLinks ? "pv" : "p";
	return `${baseURL}/${previewScope}/${publicId}`;
}

export function buildSharableLink(publicId, creative = {}, useVersionLinks = false){
	const baseURL = getPreviewURLForCreative(creative);
	const previewScope = useVersionLinks ? "pv" : "p";
	return `${baseURL}/${previewScope}/${publicId}`;
}

export function getPreviewURLForCreative(creative){
	const { adType, origin } = creative || {};

	if(getPRVW()){
		return PREVIEW_2_URL;
	}

	if(adType === DYNAMIC_PREROLL){
		if(origin === "after_effects" || origin === "imposium"){
			return PREVIEW_2_URL;
		}
		/*
			DVAST (DYNAMIC_PREROLL) are supported in the Preview 2 app, but their versions
			aren't yet, so we need a special case here.
		*/
		return TIA_DOMAIN_PUBLIC;
	}
	if(PREVIEW_2_ADTYPES.includes(adType)){
		return PREVIEW_2_URL;
	}
	return TIA_DOMAIN_PUBLIC;
}
